<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    style="shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd"
    viewBox="0 0 31 31"
    xmlns:xlink="http://www.w3.org/1999/xlink">
     <g id="__x0023_Layer_x0020_1">
       <path :style="{fill: getColor}" style="fill-rule:nonzero"
             d="M10 0c-8,0 -10,7 -10,10 0,3 1,6 3,7 1,1 2,1 2,4 0,2 2,2 2,2l3 0 0 0 3 0c0,0 1,0 2,-2 0,-3 1,-3 2,-4 1,-1 3,-4 3,-7 0,-3 -3,-10 -10,-10z"/>
       <path class="fil1" style="fill:#C5C6C6; fill-rule:nonzero"
             d="M12 25l-2 0 0 0 -3 0c0,0 -1,0 -1,2 0,1 0,2 1,2 0,0 1,2 1,2l2 0 0 0 2 0c0,0 1,-2 1,-2 1,0 1,-1 1,-2 0,-2 -2,-2 -2,-2z"/>
     </g>
    </svg>
</template>

<script>
export default {
  name: 'Light',
  props: {
    isSwitchedOn: {
      type: Boolean,
      default: false,
      required: false,
    },
    switchOnColor: {
      type: String,
      default: '#FFED00',
      required: false,
    },
  },
  data() {
    return {
      switchOffColor: '#C5C6C6',
    };
  },
  computed: {
    getColor() {
      return this.isSwitchedOn ? this.switchOnColor : this.switchOffColor;
    },
  },
};
</script>

<style scoped>

</style>
